import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../font-drawer.module.scss';
import { CUIText } from '@dotcom/crown-ui';

export const FontDrawerHeader = () => {
  const { t } = useTranslation();
  return (
    <>
      <CUIText variant="h2" className={styles['headline']}>
        {t('fontDrawer.headline')}
      </CUIText>
    </>
  );
};
